export * from "./convertCurrency";
export * from "./splitTransactions";
export const generateRandomColor = () => {
    const r = Math.floor(Math.random() * 220 + 36);
    const g = Math.floor(Math.random() * 220 + 36);
    const b = Math.floor(Math.random() * 220 + 36);
    const a = Math.random().toFixed(2);
    return `rgba(${r}, ${g}, ${b}, ${a})`;
};
export const sortByCreatedAt = (objects) => {
    return objects
        .slice()
        .sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());
};
